export default {
  promoCodes: (state) => state.promoCodes,
  loading: (state) => state.loading,
};
